import { ITagsSchema } from './tags-schema.interface';
import { ITripSchema } from './trip-schema.interface';

export interface IOriginDestination {
    checkpointIndex: number;
    name: string;
    plannedAt?: string;
    triggeredAt?: string;
    triggeredAtISOString?: string;
    departureTriggeredAt?: string;
    departureTriggeredAtISOString?: string;
}

export interface ITripStopoverInfo {
    name?: string;
    isPlanned: boolean;
    isActive: boolean;
    isCompleted: boolean;
    isSkipped: boolean;
    /** Duration in minutes (only when isCompleted) */
    duration?: number;
    /**
     * Cuánto DEBERÍA durar esta parada, en minutos: la suma de la duración normal
     * de sus steps. Es contra esto que se mide si una permanencia es atípica, en
     * vez de contra un número fijo igual para toda la operación.
     */
    normalDuration?: number;
    /** Planned arrival date for upcoming planned stopovers */
    plannedAt?: string;
    /** ETA for upcoming stopovers */
    eta?: string;
    arrivalTriggeredAt?: string;
    departureTriggeredAt?: string;
    /** Fallbacks to identify the stopover when it has no name (no nearby location) */
    address?: string;
    latitude?: string;
    longitude?: string;
}

/**
 * The trip's section ("tramo") standing for the table view.
 */
export interface ITripTableSection {
    /** Section currently in charge: the one opened by the last **completed** handover. */
    number: number;
    /** Every section the trip plans, reached or not — `nº cambios + 1`. */
    total: number;
}

export interface ITripsTableSchema extends ITripSchema {
    distance: string;
    time: string;
    status: string;
    tripDefinitionName?: string;
    deviceLastReport?: string;
    isDeviceReporting?: boolean; // indicates if the device is currently reporting (< 30 minutes old)
    hasDevice?: boolean; // indicates if the trip has an associated device
    // not in use
    tags?: string[] | ITagsSchema[];
    consolidatedTripOrders: {
        totalPendingOrders: number;
        totalSucceededOrders: number;
        totalPartialOrders?: number;
        totalFailedOrders: number;
    };
    /** Who certified the trip's most recently certified order: 'DriverApp' or the web user's name. */
    certificationSource?: string;
    origins?: IOriginDestination[];
    destinations?: IOriginDestination[];
    unseenComments?: number;
    wasManuallyTriggered?: boolean;
    hasActiveStopover?: boolean;
    stopovers?: ITripStopoverInfo[];
    section?: ITripTableSection;
    /** The trip can still be unfolded into openings. */
    isUnfoldable?: boolean;
    /** Some trip was already unfolded from this one. */
    hasUnfoldOpenings?: boolean;
}
